import React from 'react';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import { Box, Container, Grid } from '@material-ui/core';
import TitleText from '../../components/reusableComponents/TitleText';
import { useParams } from 'react-router-dom';
import FlightDealCityCard from '../../components/reusableComponents/FlightDealCityCard';
const FlightDealCity = () => {
	const { city } = useParams();
	return (
		<>
			<HeaderSection id={4} />
			<Box textAlign='center' mt={'120px'}>
				<TitleText textStyle={{ fontSize: 24, fontWeight: 500 }}>
					Special fare available for Origin Airport {city}
				</TitleText>
			</Box>
			<Container style={{ marginTop: 20 }}>
				<Grid container spacing={4}>
					{[0, 1, 2, 4].map((i) => {
						return (
							<>
								<Grid item xs={12} md={6} lg={3}>
									<FlightDealCityCard />
								</Grid>
							</>
						);
					})}
				</Grid>
			</Container>
		</>
	);
};

export default FlightDealCity;
